export default __webpack_public_path__ + "static/media/kairos.9e38998d.jpg";